import { AntDesign } from "@expo/vector-icons";
import {
  Button,
  Notification,
  useThemeProvider,
} from "@towersystems/roam-common-native";

export interface FilterButtonProps {
  appliedFilters: number;
  onPress?: () => void;
}

export function FilterButton({ appliedFilters, onPress }: FilterButtonProps) {
  const { colors, spacings } = useThemeProvider();

  const hide = !appliedFilters;

  return (
    <Notification top right embedded content={`${appliedFilters}`} hide={hide}>
      <Button
        size="compact"
        aria-label="open filters"
        onPress={onPress}
        label="Filter"
        style={{ display: "flex" }}
        stackProps={{
          vertical: false,
          centerVertical: true,
          spacing: spacings.s2,
        }}
      >
        <AntDesign name="filter" size={24} color={colors.text} />
      </Button>
    </Notification>
  );
}
